import axios from 'axios';
import { ApiConfig } from '../api/apiClient';

const declOfNum = (number: number, titles: string[]) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
};

const isMainHost = (): boolean =>
  ['moneyfriends.ru', 'www.moneyfriends.ru'].includes(window.location.host);

const toAbsoluteUrl = (url: string) => {
  if (!(url.includes('://') || url.indexOf('//') === 0)) {
    const config = makeConfig();
    const { apiDomain } = config;
    return `${apiDomain}${url}`;
  }
  return url;
};

const makeConfig = (): ApiConfig => {
  const { origin, protocol, hostname } = window.location;
  const wsProtocol = protocol === 'http:' ? 'ws:' : 'wss:';

  const hostnameParsed = hostname.replace('www.', '');

  const defaults = {
    [origin]: {
      apiDomain: isMainHost() ? 'https://api.moneyfriends.ru' : origin,
      apiUrl: isMainHost()
        ? 'https://api.moneyfriends.ru/v1/'
        : `${protocol}//${hostnameParsed}/v1/`,
      socketUrl: `${wsProtocol}//socket.${hostnameParsed}/base`,
    },
  };

  const { urlConfig } = window as any;

  if (urlConfig && urlConfig[origin]) {
    return { ...defaults, ...urlConfig }[origin];
  }

  return defaults[origin];
};

const errorToString = (e: unknown): string => {
  let errorData = e;
  if (e instanceof axios.AxiosError) {
    errorData = e.response?.data;
  }
  if (Array.isArray(errorData)) {
    return errorData.map((v) => v.message).join(', ');
  }
  return '';
};

export const reachGoalYandex = (
  target: string,
  params: unknown = null
): void => {
  const w: Window & {
    yaCounter50555941?: { [key: string]: unknown };
  } = window;
  if (isMainHost()) {
    console.log('reachGoalYandex', target);
    const yaCounter = w.yaCounter50555941;
    if (yaCounter && typeof yaCounter.reachGoal === 'function') {
      yaCounter.reachGoal(target, params);
    } else {
      window.console.log('Yandex counter offline');
    }
  }
};

export const scrollToError = (
  errorClass: string | string[] = '.error, .Mui-error',
  parentClass = ''
) => {
  const errorCollection = document.querySelectorAll(
    Array.isArray(errorClass) ? errorClass.join(', ') : errorClass
  );
  const errorElement = errorCollection.item(0);
  if (errorElement) {
    let parent = parentClass ? errorElement.closest(parentClass) : null;
    if (!parent) {
      parent = errorElement.parentElement;
    }
    parent?.scrollIntoView({
      block: 'center',
      inline: 'center',
      behavior: 'smooth',
    });
    return true;
  }
  return false;
};

export { declOfNum, isMainHost, toAbsoluteUrl, makeConfig, errorToString };
